import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';

// Import reducers here
import { coursesLitmosReducer } from './coursesLitmosReducer';
import { slidesLitmosReducer } from './slidesLitmosReducer';
import { explanationLitmosReducer } from './explainerReducer';
import { quizLitmosReducer } from './quizLitmosReducer';
import { loadLitmosReducer } from './loadLitmosReducer';
import { customStylesReducer } from './customStylesReducer';
import { createStyleTag } from './customStylesMiddleware';
import { learnerReducer } from './learnerReducer';

const initialState = {};

const rootReducer = combineReducers({
  coursesLitmos: coursesLitmosReducer,
  slidesLitmos: slidesLitmosReducer,
  explanation: explanationLitmosReducer,
  quizLitmos: quizLitmosReducer,
  loadLitmos: loadLitmosReducer,
  customStyles: customStylesReducer,
  learner: learnerReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default function configureStore() {
  return createStore(
    rootReducer,
    initialState,
    composeWithDevToolsDevelopmentOnly(applyMiddleware(thunk, createStyleTag)),
  );
}
